import StoreState, { createAppAsyncThunk } from 'store/state'
import { listsAdapter } from './adapters/lists'
import { userListsSelector } from './selectors'

import { firstValueFrom } from 'rxjs'
import { V1 } from './net'
import { connectedDestinationsSelector } from 'services/destinations'

export const getLists = createAppAsyncThunk(
  'lists/get',
  async (force: boolean = false, { dispatch, getState }) => {
    const state = getState() as StoreState

    if (!force) {
      const storedLists = userListsSelector(state) as any
      const keys = Object.keys(storedLists)
      if (keys.length > 1) {
        return keys.map(key => storedLists[key])
      }
    }

    const connectedPages = connectedDestinationsSelector(state)
    const connectedPageIds = Object.keys(connectedPages)

    const response = await firstValueFrom(dispatch(V1.getLists()))
    return listsAdapter(response, connectedPageIds)
  }
)

export const updateList = createAppAsyncThunk(
  'lists/update',
  async (list: { id: string, name: string, pages: string[] }, { dispatch }) => {
    await firstValueFrom(dispatch(V1.updateList(list.id, list.name, list.pages)))
    return list
  }
)

export const createList = createAppAsyncThunk(
  'lists/create',
  async (list: { name: string, pages: string[] }, { dispatch, getState }) => {
    const lists = userListsSelector(getState() as StoreState)
    const response = await firstValueFrom(dispatch(V1.createList(list.name, list.pages)))
    dispatch(getLists(true))
    return { ...list, id: response.listId, order: Object.keys(lists).length }
  }
)

export const deleteList = createAppAsyncThunk(
  'lists/delete',
  async (id: string, { dispatch }) => {
    await firstValueFrom(dispatch(V1.deleteList(id)))
    return id
  }
)

export const reorderLists = createAppAsyncThunk(
  'lists/reorder',
  async (ids: string[], { dispatch }) => {
    await firstValueFrom(dispatch(V1.reorderLists(ids)))
    return ids
  }
)
